
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';
import ScrollToTop from './components/ScrollToTop';
import CookieConsent from './components/CookieConsent';
import GoogleAnalytics from './components/GoogleAnalytics';
import Home from './pages/Home';
import Issue from './pages/Issue';
import Archive from './pages/Archive';
import Viewer from './pages/Viewer';
import AdminAtelier from './pages/AdminAtelier';
import AdminLogin from './pages/AdminLogin';
import TestImagePage from './pages/TestImagePage';
import DynamicPage from './pages/DynamicPage';
import HighlightDetail from './pages/HighlightDetail';
import Locations from './pages/Locations';

import SchemaOrg from './components/SchemaOrg';
import SEOHead from './components/SEOHead';

import Breadcrumbs from './components/Breadcrumbs';

const App: React.FC = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const session = localStorage.getItem('vanity_atelier_session');
    if (session) {
      setIsLoggedIn(true);
    }
  }, []);

  const handleAdminSuccess = () => {
    setIsLoggedIn(true);
    localStorage.setItem('vanity_atelier_session', 'active');
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    localStorage.removeItem('vanity_atelier_session');
    window.location.href = '/';
  };

  return (
    <Router>
      <SEOHead />
      <SchemaOrg />
      <ScrollToTop />
      <Routes>
        {/* PDF Viewer - Standalone (no layout) */}
        <Route path="/viewer/:issueId" element={<Viewer />} />

        {/* Admin Routes */}
        <Route path="/vanityadmin/*" element={
          isLoggedIn ? (
            <AdminAtelier onLogout={handleLogout} />
          ) : (
            <AdminLogin onSuccess={handleAdminSuccess} onCancel={() => window.location.href = '/'} />
          )
        } />

        {/* Public Routes with Main Layout */}
        <Route path="*" element={
          <div className="min-h-screen flex flex-col font-sans bg-vanity-white">
            <Header />
            <Breadcrumbs />

            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/latest" element={<Issue />} />
                <Route path="/archive" element={<Archive />} />
                <Route path="/archive/:slug" element={<Issue />} />
                <Route path="/test-image" element={<TestImagePage />} />
                <Route path="/locations" element={<Locations />} />

                {/* Highlights Routes (Decoupled & Attached) */}
                <Route path="/highlight/:slug" element={<HighlightDetail />} />
                <Route path="/highlights/:slug" element={<HighlightDetail />} />
                <Route path="/:issueSlug/:slug" element={<HighlightDetail />} />

                {/* Dynamic Pages */}
                <Route path="/:slug" element={<DynamicPage />} />
              </Routes>
            </main>

            <BackToTop />
            <Footer />
          </div>
        } />
      </Routes>

      {/* Global Cookie Consent - Shows on first visit */}
      <CookieConsent />

      {/* Google Analytics - Respects cookie consent */}
      <GoogleAnalytics />
    </Router>
  );
};

export default App;
